import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap'
import { Image } from 'semantic-ui-react'
import { Container, Row, Col } from 'react-bootstrap'
import Footer from './compo/Footer';
import Resume from './pages/Resume';
import Cv from './pages/Cv';

class App extends Component {
  render() {
    return (
      <>
        <Router>
          <div>
            <Container>
              <Row>
                <Col>
                  <Navbar bg="light" expand="lg" >
                    <Navbar.Brand >
                      <Link to="/">
                        <Image src='http://2.bp.blogspot.com/-7Y0KPg8QstA/VL4eWVxCUMI/AAAAAAAAAoY/qh1rWHt-3nM/s1600/alquera%2B2.png' size='mini' circular />
                      </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav className="ml-auto">
                        <Link className="nav-link" to='/'>
                          Home
                        </Link>
                        <Link className="nav-link" to='/cv'>
                          About Me
                        </Link>
                      </Nav>
                    </Navbar.Collapse>
                  </Navbar>
                </Col>
              </Row>
            </Container>

            {/* ============================================================================ */}
            <Route path="/" exact component={Resume} />
            <Route path="/cv" component={Cv} />
          </div>
        </Router>
        <Footer />
      </>
    );
  }
}

export default App;
